module.exports = __webpack_public_path__ + "img/carlos.750cbd2b.jpg";